import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    SignupBackgroundLayout,
    JSMOverlayTemplate
} from "@/components/signup/layouts";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { experiments, ExperimentView } from "@/utils/experiment";

import { GetStartedHeading, SubHeading } from "../components";

const LoggedOutContent = () => (
    <>
        <GetStartedHeading productName="Service Collection" />
        <SubHeading>
            <FormattedMessage
                id="signup.serviceCollection.subHeading"
                defaultMessage="It’s free for up to 3 agents - no credit card needed."
            />
        </SubHeading>
        <AccountCreation />
    </>
);

export const LoggedOut = () => (
    <ExperimentView
        experiment={experiments.gwp9785ServcoLofiExperiment}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <LoggedOutContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <LoggedOutContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
